import React from 'react';
import { UserSearch, School, FileCheck2, PlaneTakeoff, ArrowRight } from 'lucide-react';
import { processSteps } from '../mock';
import Reveal from './shared/Reveal';
import SectionHeader from './shared/SectionHeader';

const stepIcons = [UserSearch, School, FileCheck2, PlaneTakeoff];

const ProcessSteps = () => {
  return (
    <section className="py-20 lg:py-28 bg-white relative overflow-hidden">
      <div className="container-x">
        <SectionHeader
          eyebrow="How it works"
          title={<>Four steps. <span className="text-brand-500">One journey.</span></>}
          subtitle="A clear, proven path from your first counseling session to boarding your flight."
        />

        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-[44px] left-[12%] right-[12%] h-px bg-gradient-to-r from-navy-100 via-brand-200 to-navy-100"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {processSteps.map((step, index) => {
              const Icon = stepIcons[index] || UserSearch;
              return (
                <Reveal key={step.step} delay={index * 120} className="relative">
                  <div className="group text-center px-4">
                    <div className="relative inline-flex">
                      <span className="w-[88px] h-[88px] rounded-3xl bg-navy-50 border border-navy-100 flex items-center justify-center text-navy-900 group-hover:bg-navy-900 group-hover:text-brand-400 group-hover:-translate-y-1.5 transition-all duration-300 shadow-soft">
                        <Icon className="w-9 h-9" />
                      </span>
                      <span className="absolute -top-2.5 -right-2.5 w-8 h-8 rounded-full bg-brand-500 text-white text-sm font-display font-bold flex items-center justify-center shadow-brand-glow">
                        {step.step}
                      </span>
                    </div>
                    <h3 className="mt-6 font-display text-lg font-bold text-navy-900">{step.title}</h3>
                    <p className="mt-2 text-sm text-slate-500 leading-relaxed max-w-[240px] mx-auto">
                      {step.description}
                    </p>
                  </div>
                  {/* Mobile/tablet arrow between steps */}
                  {index < processSteps.length - 1 && (
                    <ArrowRight className="lg:hidden w-5 h-5 text-brand-300 mx-auto mt-6 rotate-90 sm:rotate-0 sm:hidden" />
                  )}
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
